import React, { useMemo } from 'react';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { IBannerInfo } from '~/src/api/content/banners';
import PromoBanner from '~/src/features/index/Banners/PromoBannersSection/PromoBanner';

import * as ST from './styled';

interface IProps {
    bannerInfo: IBannerInfo,
}

const PromoBannerBundle = ({ bannerInfo }: IProps) => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    const extStyles = useMemo(() => ({
        descCol: {
            mobile: {
                height: 'auto',
                padding: '0',
            },
        },
        title: {
            tablet: {
                font: 'var(--bold-h3); letter-spacing: 0.01em',
            },
        },
        text: {
            laptop: {
                font: 'var(--regular-s)',
            },
        },
    }), []);

    return (
        <ST.Wrapper>
            {bannerInfo &&
                <PromoBanner
                    bannerIdx={bannerInfo.id}
                    title={bannerInfo.title}
                    description={bannerInfo.text}
                    background={bannerInfo.image_background}
                    backgroundWebp={bannerInfo.image_background_webp}
                    image={bannerInfo.image}
                    imageWebp={bannerInfo.image_webp}
                    textColor={bannerInfo.text_color}
                    buttonText={bannerInfo.button_text}
                    buttonType={isMobile ? 'primary' : bannerInfo.button_type}
                    tags={bannerInfo.tags}
                    route={bannerInfo.link}
                    legal={{
                        ageLimit: bannerInfo.age_limit,
                        text: bannerInfo.legal_info,
                        textColor: bannerInfo.legal_info_text_color,
                    }}
                    extStyles={extStyles}
                    advertising={bannerInfo.advertising}
                />
            }
        </ST.Wrapper>
    );
};

export default PromoBannerBundle;
